import { useDispatch, useSelector } from "react-redux";
import Modal from "../UI/Modal";
import {
  closeFormModal,
  openViewModal,
} from "../../store/frasesSeleccionAplicacion/frasesSeleccionAplicacion.reducer";
import { useEffect, useState } from "react";
import {
  updateFraseSeleccionAplicacionThunk,
  getFrasesSeleccionAplicacionThunk,
  getFraseSeleccionAplicacionByIdThunk,
} from "../../store/frasesSeleccionAplicacion/frasesSeleccionAplicacion.thunks";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import { toast } from "react-toastify";

const FraseSeleccionAplicacionFormModal = () => {
  const dispatch = useDispatch();
  const { formModalOpen, selectedFrase, formLoading, formError, page, search } =
    useSelector((state) => state.frasesSeleccionAplicacion);

  const [formData, setFormData] = useState({
    frase: "",
  });

  useEffect(() => {
    if (selectedFrase) {
      setFormData({
        frase: selectedFrase.frase || "",
      });
    }
  }, [selectedFrase, formModalOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await dispatch(
      updateFraseSeleccionAplicacionThunk({
        id: selectedFrase.id,
        payload: formData,
      }),
    );

    if (result.meta.requestStatus === "fulfilled") {
      dispatch(getFrasesSeleccionAplicacionThunk({ page, search }));
      toast.success("Frase actualizada exitosamente");
      await dispatch(getFraseSeleccionAplicacionByIdThunk(selectedFrase.id));
      dispatch(openViewModal());
    }
  };

  return (
    <Modal
      open={formModalOpen}
      onClose={() => dispatch(closeFormModal())}
      title="Editar frase"
      size="lg"
    >
      {formLoading ? (
        <Loader center type="dots" text="Actualizando frase..." />
      ) : (
        <form onSubmit={handleSubmit}>
          {formError && <Alert message={formError} variant="error" />}

          <div className="mb-3">
            <label className="form-label fw-medium">
              Frase <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="frase"
              value={formData.frase}
              onChange={handleChange}
              placeholder="Ingrese la frase"
              rows="4"
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => dispatch(closeFormModal())}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Guardar cambios
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default FraseSeleccionAplicacionFormModal;
